import { render, staticRenderFns } from "./ai.vue?vue&type=template&id=aed3b2ac"
import script from "./ai.vue?vue&type=script&lang=ts"
export * from "./ai.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports